export enum ContactActionKeys {
  ACTIVATE_CONTACT = 'ACTIVATE_CONTACT',
  ADD_CONTACT = 'ADD_CONTACT',
  ADD_CONTACT_FULFILLED = 'ADD_CONTACT_FULFILLED',
  ADD_CONTACT_REJECTED = 'ADD_CONTACT_REJECTED',
  DEACTIVATE_CONTACT = 'DEACTIVATE_CONTACT',
  FETCH_CONTACTS = 'FETCH_CONTACTS',
  FETCH_CONTACTS_BY_ID = 'FETCH_CONTACTS_BY_ID',
  FETCH_CONTACTS_FULFILLED = 'FETCH_CONTACTS_FULFILLED',
  FETCH_CONTACTS_REJECTED = 'FETCH_CONTACTS_REJECTED',
  PROCESS_CONTACTS = 'PROCESS_CONTACTS',
  UPDATE_CONTACT = 'UPDATE_CONTACT',
  UPDATE_CONTACT_FULFILLED = 'UPDATE_CONTACT_FULFILLED',
  UPDATE_CONTACT_REJECTED = 'UPDATE_CONTACT_REJECTED'
}
